import { useState, useEffect } from 'react';

// Non-sensitive UI preference flag: remembers that the popup was already shown.
const wasAlreadyShown = (key) => {
  try {
    return Boolean(window.localStorage.getItem(key));
  } catch (error) {
    console.error('Failed to read popup display flag:', error);
    return false;
  }
};

const markAsShown = (key) => {
  try {
    window.localStorage.setItem(key, '1');
  } catch (error) {
    console.error('Failed to persist popup display flag:', error);
  }
};

const useDelayedPopup = (storageKey, delayMs, onShow) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (wasAlreadyShown(storageKey)) return undefined;

    const timer = setTimeout(() => {
      setOpen(true);
      markAsShown(storageKey);
      if (onShow) onShow();
    }, delayMs);

    return () => clearTimeout(timer);
  }, [storageKey, delayMs, onShow]);

  return [open, setOpen];
};

export default useDelayedPopup;
